<template>
  <div id="map" class="gmap">
  </div>
</template>

<script>
import gmapsInit from '../utils/gmaps'

export default {
  name: 'GMap',
  data () {
    return {
      map: null,
      lat: 0,
      lng: 0
    }
  },
  created () {
    if ((!this.$route.query.lat && !this.$route.query.lng) || (isNaN(this.$route.query.lat) && isNaN(this.$route.query.lng))) {
      this.lat = 33.242215
      this.lng = 131.6392247
    } else {
      this.lat = parseFloat(this.$route.query.lat)
      this.lng = parseFloat(this.$route.query.lng)
    }
  },
  async mounted () {
    const google = await gmapsInit()
    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: 16,
      center: { lat: this.lat, lng: this.lng },
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_CENTER,
        mapTypeIds: ['roadmap', 'terrain']
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER
      },
      scaleControl: true,
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      },
      fullscreenControl: true
    })
  }
}
</script>

<style scoped>

.gmap {
  height: 100%;
}

</style>
